import styled from "styled-components"
// import { receiptsBackground } from "../static/img/receiptsBG.svg"
import receiptsBackground from "./receiptsBG.svg"

let colors = {
  primaryColor: "#a62991",
}

export const StyleMainWrapper = styled("div")`
  font-family: "Poppins", Arial, sans-serif;

  strong {
    font-weight: 700 !important;
  }
  .cls-button-mode {
    border-radius: 40px !important;
    height: 44px;
    font-size: 14px;
  }

  .cls-sub-error-head-content-text {
    margin-bottom: 15px;
    font-size: 14px;
    width: 100%;
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 10px;
  }
  .cls-sub-error-head-content-svt-text {
    font-size: 13px;
    font-weight: 300;
  }
  .cls-sub-error-head-content-svtv-text {
    font-size: 16px;
    font-weight: 500;
  }
  .cls-sub-error-head-content-svg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .cls-sub-error-content-head-text {
    font-size: 15px;
    font-weight: 500;
  }
  .cls-sub-error-content-subhead-text {
    font-size: 13px;
    font-weight: 300;
  }
  .cls-sub-error-content-text {
    margin-top: 20px;
    font-size: 24px;
    flex-direction: column;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cls-sub-error-content {
    background: #fff;
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--receipt-button-secondary-color);
    width: 100%;
    border-radius: 12px;
    padding: 18px;
    box-sizing: border-box;
    box-shadow: 0 6px 18px rgba(142, 44, 143, 0.25);
  }
  .cls-sub-no-receipt-content {
    justify-content: center;
    align-items: center;
    background: #fff;
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--receipt-button-secondary-color);
    width: 100%;
    border-radius: 12px;
    padding: 18px;
    box-sizing: border-box;
    box-shadow: 0 6px 18px rgba(142, 44, 143, 0.25);
  }

  .cls-status-txt-kit {
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 600;

    &.cls-payment-failed {
      color: #b41818;
    }
    &.cls-payment-completed {
      color: #18b477;
    }

    .cls-status-subtxt-kit {
      color: #7e7e7e;
      font-weight: 300;
      font-size: 13px;
      margin-left: 5px;
    }
  }

  .cls-sub-header-kit {
    svg path {
      fill: var(--receipt-button-secondary-color);
    }
  }

  .cls-email-capture {
    background: #fbf6fc;
    border: 1.5px solid #c96bc8;
    border-radius: 16px;
    padding: 18px 16px 16px;
    margin-bottom: 8px;
    box-sizing: border-box;
  }
  .cls-email-capture-head {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 18px;
  }
  .cls-email-capture-icon {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 50%;
    background: #f3e4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a62991;
  }
  .cls-email-capture-title {
    color: #a62991;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
  }
  .cls-email-capture-sub {
    color: #6b7280;
    font-size: 14px;
    font-weight: 400;
    margin-top: 4px;
    line-height: 1.4;
  }
  .cls-email-capture-label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 8px;
  }
  .cls-email-capture-label span {
    color: #e11d48;
    margin-left: 2px;
  }
  .cls-email-capture-input {
    width: 100%;
    box-sizing: border-box;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    background: #fff;
    padding: 0 12px;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    color: #111827;
  }
  .cls-email-capture-input:focus {
    border-color: #a62991;
  }
  .cls-email-capture-error {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #ef4444;
    font-size: 13px;
    font-weight: 500;
    margin-top: 8px;
  }
  .cls-email-capture-error-icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ef4444;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .cls-email-capture-submit {
    width: 100%;
    margin-top: 16px;
    height: 46px;
    border: none;
    border-radius: 10px;
    background: #a62991;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
  }
  .cls-email-capture-submit:disabled {
    opacity: 0.7;
    cursor: default;
    background: #08080870;
  }
`
export const StyleMainHeaderWrapper = styled("div")`
  width: 100%;
  height: 60px;
  background: var(--receipt-header-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 33px;
    width: auto;
  }
  position: fixed;
  z-index: 9999;
  top: 0px;
`
export const StyleMainContentWrapper = styled("div")`
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  max-width: 480px;
  margin: auto;
  padding-top: 50px;
`

export const StyleMainUIWrapper = styled("div")`
  min-height: 100vh;
  background: linear-gradient(
      to bottom,
      #ffffff 0%,
      #ffffff 50%,
      transparent 60%
    ),
    url(${receiptsBackground});
  background-size: stretch;
  background-repeat: repeat;
  background-position: bottom center;
`

export const StyleReceiptMainWrapper = styled("div")``

export const StyleReceiptItemWrapper = styled("div")`
  width: 100%;
  // min-height: 400px;
  border: 1px solid var(--receipt-primary-color);
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  margin-bottom: 20px;
  font-family: "Poppins", Arial, sans-serif;
  background: #fff;
  box-shadow: 0 6px 18px rgba(142, 44, 143, 0.25);
  /**Header Design */
  .receipt-header {
    color: #111;
    position: relative;
  }
  .cls-button-mode.cls-download-button {
    position: absolute;
    right: 3px;
    top: 3px;
    border-color: var(--receipt-button-secondary-color);
    color: var(--receipt-button-secondary-color);
    height: 34px;
  }
  .receipt-header .header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
  }
  /* Receipt badge */
  .receipt-badge {
    padding: 10px 30px;
    border-radius: 60px;
    border: 2px solid var(--receipt-primary-color);
    font-size: 16px;
    font-weight: 600;
    background: #fff;
    ${"" /* box-shadow: 0 6px 18px rgba(142, 44, 143, 0.25); */}
    width: 100%;
    box-sizing: border-box;

    /* Fix for single line */
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  /* Right details */
  .transaction-details {
    text-align: left;
    max-width: 420px;
  }
  .transaction-id {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .store-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .store-info {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .date-time {
    font-size: 14px;
  }

  .receipt-container-item {
    padding: 6px;
    border-radius: 8px;
    box-sizing: border-box;
    background: var(--receipt-blue-color);
  }
  /* Greeting */
  .greeting h2 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
  }
  .greeting h3 {
    margin-bottom: 6px;
    padding-left: 8px;
    font-size: 16px;
    font-weight: 500;
    margin-top: 7px;
  }
  .greeting p {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 12px;
  }
  /** Content Design */
  .table-card {
    max-width: 900px;
    margin: 10px auto;
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
  .product-table {
    width: 100%;
    border-collapse: collapse;
  }
  .product-table thead {
    background: #b8c9d9;
  }
  .product-table th {
    padding: 12px;
    text-align: center;
    font-size: 12px;
    color: #2d3a45;
    font-weight: 600;
  }
  .product-table th.left {
    text-align: left;
    padding-left: 12px;
  }
  .product-table td {
    padding: 12px;
    text-align: center;
    border-top: 1px solid #e6e6e6;
    font-size: 13px;
    color: #444;
  }
  .product-table td.left {
    text-align: left;
    padding-left: 13px;
  }
  .product-table tbody tr:nth-child(even) {
    background: #fafafa;
  }
  .bold {
    font-weight: 700;
  }
  tfoot td {
    background: #f3f3f3;
    font-size: 14;
    padding: 18px;
  }
  .footer-left {
    text-align: center;
    font-weight: 600;
  }
  .footer-label {
    text-align: right;
    font-weight: 600;
  }
  .footer-total {
    font-weight: 700;
    font-size: 18px;
  }

  /**Footer Design */
  .footer-container {
    padding: 8px;
    padding-left: 2px;
    padding-right: 2px;
  }
  .footer-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .footer-left {
    flex: 1;
  }
  .footer-text {
    font-size: 13px;
    color: #444;
    line-height: 1.4;
    text-align: left;
    font-weight: 400;
  }
  .brand {
    font-size: 13px;
    text-align: left;
    font-weight: 400;
  }
  .footer-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
  .footer-image {
    width: 160px;
    height: auto;
  }
  .divider {
    margin: 30px 0;
    height: 1px;
    background: #ddd;
  }
  .footer-bottom {
    text-align: center;
  }
  .contact-title {
    font-size: 14px;
    color: #000000;
    margin-bottom: 20px;
    font-weight: 400;
  }
  .contact-info {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .contact-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #000000;
    font-weight: 500;

    .icon img {
      width: 22px;
      height: auto;
    }
  }
  .icon {
    font-size: 24px;
  }

  .cls-download-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .cls-footer-total-ui {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    row-gap: 10px;
    column-gap: 10px;
    padding: 5px;
  }
`

export const StyleReceiptItemListWrapper = styled("div")`
  font-size: 13px;
`
export const StyleReceiptCardItemWrapper = styled("div")`
  font-size: 13px;
  display: flex;

  -webkit-column-gap: 4px;
  column-gap: 4px;
  padding: 8px;
  box-sizing: border-box;
  box-shadow: 2px 3px 0px #0000000f;
  background-color: var(--receipt-white-color);
  margin-bottom: 8px;
  border-radius: 6px;
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  flex-direction: column;

  .cls-left-kit {
    width: 100%;
    display: flex;
  }
  .cls-right-kit {
    box-sizing: border-box;
    display: flex;
    width: 100%;
    justify-content: space-between;
    background: #f8fcff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #e5f1ff;
  }

  .cls-price-txt {
    padding-left: 4px;
    margin-left: 4px;
    border-left: 1px solid #bfbfbf;
  }
  .cls-tax-txt {
    width: fit-content;
    background: #f8fcff;
    border-radius: 4px;
    padding: 1px 3px;
  }
  .cls-total-txt {
    background: #e8f3ff;
    width: fit-content;
    border-radius: 4px;
    margin-bottom: 2px;
    padding: 1px 3px;
  }
  .cls-product-name-kit {
    margin-bottom: 4px;
    padding-bottom: 3px;
    font-weight: 600;
    width: 100%;
    word-break: break-word;
  }

  .cls-txt-bold {
    font-weight: 600;
  }
  .cls-qty-price-txt {
    display: flex;
    font-size: 12px;
    text-align: right;
    justify-content: flex-end;
  }
  .cls-right-total-kit {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    width: fit-content;
    background: #f8fcff;
  }

  .cls-price-value {
    padding: 2px 8px;
    background: #f0f7ff;
    width: fit-content;
    border-radius: 4px;
  }
`
